export const LANGUAGE_SUPPORT = {
  en: 'en',
  vi: 'vi',
}

export type LanguageSupportType = keyof typeof LANGUAGE_SUPPORT
